import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PageTitle from "components/PageTitle";
import PageMeta from "components/PageMeta";
import { useText } from "context/TextProvider";
import { trackEvent } from "services/analytics.service";
import { AnalyticsEvent, DeviceGrantStep } from "services/analyticsEvents";
import { useScreenTimeTracking } from "hooks/useScreenTimeTracking";
const DeviceGrantComplete = (): JSX.Element => {
  const text = useText();
  useScreenTimeTracking(AnalyticsEvent.TIME_ON_DEVICE_COMPLETE_SCREEN);

  useEffect(() => {
    trackEvent(AnalyticsEvent.DEVICE_GRANT_COMPLETE, { step: DeviceGrantStep.COMPLETE });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ textAlign: "center" }}>
      <PageMeta name="Device Grant Complete" />
      <PageTitle>{text.deviceGrant.complete.title}</PageTitle>
      <Typography component="p" sx={{ mb: "2rem", fontSize: "1.125rem", fontWeight: 500, color: "text.secondary" }}>
        {text.deviceGrant.complete.messageLine1}<br/>
        {text.deviceGrant.complete.messageLine2}
      </Typography>
    </Box>
  );
};

export default DeviceGrantComplete;
